module.exports = __webpack_public_path__ + "media/images/shared/tag-4540ea2079c838d4f4f4a66b5d92e8d2.png";